import { render } from "./LesBibliotheques.vue?vue&type=template&id=d576e4a8&scoped=true&ts=true"
import script from "./LesBibliotheques.vue?vue&type=script&lang=ts"
export * from "./LesBibliotheques.vue?vue&type=script&lang=ts"

import "./LesBibliotheques.vue?vue&type=style&index=0&id=d576e4a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d576e4a8"]])

export default __exports__